"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateNotificationPreferences = exports.fetchNotificationPreferences = exports.useSubscriptionTypes = exports.useNotificationEvents = exports.useNotificationTypes = void 0;
const react_1 = require("react");
const abortable_fetch_1 = require("../../utils/abortable-fetch");
const list_source_hook_1 = require("../../utils/list-source-hook");
const notification_context_1 = require("./notification-context");
function useNotificationTypes() {
    const { notificationUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${notificationUrl}/type/list`,
        method: 'GET',
    });
}
exports.useNotificationTypes = useNotificationTypes;
function useNotificationEvents() {
    const { notificationEventUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${notificationEventUrl}/list`,
        method: 'GET',
    });
}
exports.useNotificationEvents = useNotificationEvents;
function useSubscriptionTypes() {
    const { notificationSubscriptionTypeUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${notificationSubscriptionTypeUrl}/list`,
        method: 'GET',
    });
}
exports.useSubscriptionTypes = useSubscriptionTypes;
function fetchNotificationPreferences(url) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' }),
    });
}
exports.fetchNotificationPreferences = fetchNotificationPreferences;
function updateNotificationPreferences(url, subscriptions) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(subscriptions),
    });
}
exports.updateNotificationPreferences = updateNotificationPreferences;
//# sourceMappingURL=notification-api.js.map